var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-alert" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "状态看板 / Painel de Status", name: "1" } },
            [
              _c("template", { slot: "label" }, [
                _c("div", { staticClass: "tabs-title" }, [
                  _c("div", [_vm._v("状态看板")]),
                  _c("div", [_vm._v("Painel de Status")]),
                ]),
              ]),
              _vm.activeName === "1"
                ? _c(
                    "div",
                    [
                      _c("status-board", {
                        key: _vm.cmpKey,
                        ref: "statusBoard",
                        attrs: { "expire-warn-days": _vm.expireDays },
                        on: { jump: _vm.handleJump },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "IE 信息管理 / Gestão de IE", name: "2" } },
            [
              _c("template", { slot: "label" }, [
                _c("div", { staticClass: "tabs-title" }, [
                  _c("div", [_vm._v("IE 信息管理")]),
                  _c("div", [_vm._v("Gestão de IE")]),
                ]),
              ]),
              _vm.activeName === "2"
                ? _c(
                    "div",
                    [
                      _c("ie-management", {
                        key: _vm.cmpKey,
                        ref: "ieList",
                        attrs: {
                          "expire-warn-days": _vm.expireDays,
                          "state-list": _vm.stateList,
                          "prefilter-status": _vm.pendingIeStatus,
                        },
                        on: { checked: _vm.handleBoardRefresh },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: "告警配置 / Configuração de Alertas",
                name: "3",
                lazy: "",
              },
            },
            [
              _c("template", { slot: "label" }, [
                _c("div", { staticClass: "tabs-title" }, [
                  _c("div", [_vm._v("告警配置")]),
                  _c("div", [_vm._v("Configuração de Alertas")]),
                ]),
              ]),
              _vm.activeName === "3"
                ? _c("div", [_c("alert-config", { key: _vm.cmpKey })], 1)
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "变更日志 / Log de Alterações", name: "4" } },
            [
              _c("template", { slot: "label" }, [
                _c("div", { staticClass: "tabs-title" }, [
                  _c("div", [_vm._v("变更日志")]),
                  _c("div", [_vm._v("Log de Alterações")]),
                ]),
              ]),
              _vm.activeName === "4"
                ? _c(
                    "div",
                    [
                      _c("change-log", {
                        key: _vm.cmpKey,
                        attrs: { "state-list": _vm.stateList },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "告警日志 / Log de Alertas", name: "5" } },
            [
              _c("template", { slot: "label" }, [
                _c("div", { staticClass: "tabs-title" }, [
                  _c("div", [_vm._v("告警日志")]),
                  _c("div", [_vm._v("Log de Alertas")]),
                ]),
              ]),
              _vm.activeName === "5"
                ? _c(
                    "div",
                    [
                      _c("alert-log", {
                        key: _vm.cmpKey,
                        attrs: { "state-list": _vm.stateList },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }